import React from 'react'

const Connect4 = () => {
  return (
    <section className="project">
      <p>This is a connect four game!</p>
      <iframe title="Connect4" src="https://connect4-jopemamo.netlify.app/" />
    </section>
  )
}

export default Connect4;